import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function MutasiKas() {

  //Roles
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [dataMutasi, setDataMutasi] = useState([]);
  const [dataTotal, setDataTotal] = useState({
    debit: 0,
    kredit: 0,
  });

  // CONTROLLER & LOAD DATA
  const fetchMutasi = async () => {
    await axios
      .all(
        [
        baseAPI .get(`/v1/mutasikas`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const mutasi = res[0].data.data.data_mutasi;
        const totalDebit = res[0].data.data.total_debit;
        const totalKredit = res[0].data.data.total_kredit;

        setDataMutasi(mutasi);
        setDataTotal({total_debit: totalDebit, total_kredit: totalKredit});
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    if (users.role === BENDAHARA) {
      fetchMutasi();
    }
  }, [token]);

  
  // View
  const mutasiView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Tgl Mutasi',
        id: 'tglmutasi',
        width: '8%',
        accessor: 'tglmutasi',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.tgl_mutasi).format('DD-MM-YYYY')}</div>
      },
      {
        Header: 'No Transaksi',
        id: 'notrx',
        width: '8%',
        accessor: 'notrx',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.no_trx}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.nama_trx}</div>
      },
      {
        Header: 'Deskripsi',
        id: 'deskripsi',
        width: '10%',
        accessor: 'deskripsi',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.deskripsi}</div>
      },
      {
        Header: 'Debit',
        id: 'debit',
        width: '8%',
        accessor: 'debit',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.debit).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Kredit',
        id: 'kredit',
        width: '8%',
        accessor: 'kredit',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.kredit).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Kode Transaksi',
        id: 'kode',
        width: '8%',
        accessor: 'kode',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.kode_trx}</div>
      },
      {
        Header: 'Submitted By',
        id: 'submittedby',
        width: '8%',
        accessor: 'submittedby',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.submit_by}</div>
      },
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Mutasi Kas"
                columns={columns}
                data={dataMutasi}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Kas</Link> /{' '}
                <Link to='/kas/mutasikas' style={{ color: '#333' }}>Mutasi Kas</Link>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  )

    
  return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            <b className='text-danger'>Total Kredit: {dataTotal.total_kredit !== 0 ? parseFloat(dataTotal.total_kredit).toLocaleString('id-ID') : ""}</b>
            <b className='text-danger'>Total Debit: {dataTotal.total_debit !== 0 ? parseFloat(dataTotal.total_debit).toLocaleString('id-ID') : ""}</b>
          </div>
        </div>
      </div>


      {isLoading ? <LoadingView /> : mutasiView()}      

    </div>

  );

}

export default MutasiKas;